import {Component, Prop, Vue} from "vue-property-decorator";

const AVAILABLE_ICONS = {
  upload: require("../icons/upload.icon.svg"),
  file: require("../icons/file.icon.svg"),
  delete: require("../icons/times.icon.svg"),
  ["angle-down"]: require("../icons/angle-down.icon.svg"),
  ["angle-up"]: require("../icons/angle-up.icon.svg"),
  ["caret-down"]: require("../icons/caret-down.icon.svg"),
  ["cog"]: require("../icons/cog.icon.svg"),
  ["dot-circle"]: require("../icons/dot-circle.icon.svg"),
  ["delete-geom"]: require("../icons/delete-geom.icon.svg"),
  ["download"]: require("../icons/download.icon.svg"),
  ["draw-geom-file"]: require("../icons/draw-geom-file.icon.svg"),
  ["draw-geom"]: require("../icons/draw-geom.icon.svg"),
  ["eye"]: require("../icons/eye.icon.svg"),
  ["file-excel"]: require("../icons/file-excel.icon.svg"),
  ["file-pdf"]: require("../icons/file-pdf.icon.svg"),
  ["flask"]: require("../icons/flask.icon.svg"),
  ["map-marker"]: require("../icons/map-marker.icon.svg"),
  ["map-pin"]: require("../icons/map-pin.icon.svg"),
  ["pen"]: require("../icons/pen.icon.svg"),
  ["question-circle"]: require("../icons/question-circle.icon.svg"),
  ["save"]: require("../icons/save.icon.svg"),
  ["sign-out"]: require("../icons/sign-out.icon.svg"),
  ["trash"]: require("../icons/trash.icon.svg"),
  ["warning"]: require("../icons/warning.icon.svg"),
  ["window-close"]: require("../icons/window-close.icon.svg")
};

@Component
class Icon extends Vue {

  @Prop({default: "span", type: String}) readonly tag: string;
  @Prop({required: true, type: String}) readonly icon!: string;

  created() {
    if (!AVAILABLE_ICONS[this.icon]) {
      throw new Error(`unknown icon ${this.icon}`);
    }
  }

  render(createElement) {
    return createElement(this.tag, {class: "svg-icon", domProps: {innerHTML: AVAILABLE_ICONS[this.icon]}});
  }
}

export default Icon;

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-1f96a15d/icon.tsx" });